export const UNIMPLEMENTED_STEPS: string[] = ['checkout-main-ocr'];
